/*
  Create Your Piece — product canvas (10A.07: "the evolving piece, shared by
  every step"; Paper 10.32–10.35). The warm band: a read-out, the product
  photography on a white tile, and from the Piece step a Front | Back toggle.
  Front is the product photo; Back is the drawn plate (shell backPlate) with
  the live engraving or the crest outline. Default is Front up to Finish and
  Back from Personalize on; a choice made with the toggle holds until the
  step changes. Also owns every running total and announces price changes.
*/
(function () {
  'use strict';
  var CYP = window.PersonaCYP;
  if (!CYP) return;

  CYP.use(function (cyp) {
    var root = cyp.root;
    var cv = root.querySelector('[data-pb-canvas]');
    var $ = function (sel) { return cv.querySelector(sel); };
    var eyebrow = $('[data-cv-eyebrow]');
    var eyebrowM = $('[data-cv-eyebrow-m]');
    var title = $('[data-cv-title]');
    var fig = $('[data-cv-figure]');
    var imgs = cv.querySelectorAll('[data-cv-img]');
    var back = $('[data-cv-back]');
    var faceBox = $('[data-cv-face]');
    var faceBtns = faceBox.querySelectorAll('[data-face-btn]');
    var thumbImg = $('[data-cv-thumb-img]');
    var note = $('[data-cv-note]');
    var cap = $('[data-cv-cap]');
    var capM = $('[data-cv-cap-m]');
    var priceLive = root.querySelector('[data-pb-price-live]');
    var WORDS = ['No', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight'];
    var cur = 0;
    var lastTotal = null;
    var face = 'front';
    var backSig = '';

    function defaultFace(st) { return st === '4' || st === '4b' ? 'back' : 'front'; }

    function setPhoto(src) {
      if (!src) {
        imgs.forEach(function (im) { im.classList.remove('is-on'); });
        return;
      }
      src = cyp.sized(src, 1000);
      if (imgs[cur].getAttribute('src') === src) { imgs[cur].classList.add('is-on'); return; }
      var next = 1 - cur;
      var a = imgs[cur], b = imgs[next];
      cur = next;
      function swap() { b.classList.add('is-on'); a.classList.remove('is-on'); }
      b.onload = swap;
      b.src = src;
      if (b.complete) swap();
    }

    // The lowest real starting price across a sport's pieces.
    function fromPrice(sp) {
      var min = null;
      sp.pieces.forEach(function (pc) {
        var q = cyp.quote({ sport: sp.slug, piece: pc.family, finish: null, type: null });
        if (q && (min === null || q.base < min)) min = q.base;
      });
      return min;
    }

    function render() {
      var s = cyp.state;
      var st = cyp.step;
      var sp = cyp.sportBy(s.sport);
      var pc = cyp.pieceBy();
      var fe = pc ? cyp.finishEntry() : null;
      var q = cyp.quote();
      var e = '', em = '', t = '', c = [], cm = '';
      var src = null, toggle = false;
      var shown = s; // the configuration drawn on the back
      var FACE = face === 'back' ? 'Back' : 'Front';

      if (st === '1') {
        e = em = '01 · Your sport';
        if (sp) {
          var n = sp.pieces.length, fp = fromPrice(sp);
          t = sp.name;
          c = [WORDS[n] + ' ' + sp.name + (n === 1 ? ' piece' : ' pieces')];
          cm = WORDS[n] + (n === 1 ? ' piece' : ' pieces');
          if (fp !== null) { c.push('from ' + cyp.money(fp)); cm += ' · from ' + cyp.money(fp); }
          src = cyp.leadImage(sp);
        }
      } else if (st === '2') {
        var p2 = pc || (sp && sp.pieces.length === 1 ? sp.pieces[0] : null);
        e = (sp ? sp.name + ' · ' : '') + '02 · Your piece';
        em = (sp ? sp.name + ' · ' : '') + '02';
        if (p2) {
          shown = Object.assign({}, s, { piece: p2.family });
          var q2 = cyp.quote(shown, { type: null });
          t = p2.name;
          src = cyp.imageFor(shown, s.finish);
          c = [FACE, 'from ' + (q2 ? cyp.money(q2.base) : '')];
          cm = c.join(' · ');
          toggle = true;
        }
      } else if (st === '3') {
        e = (sp ? sp.name : '') + (pc ? ' · ' + pc.name : '');
        em = (sp ? sp.name : '') + (pc ? ' · ' + cyp.settings.short[pc.family] : '');
        t = fe && s.finish ? fe.label : '';
        if (pc) {
          src = cyp.imageFor(s, s.finish);
          c = [FACE];
          if (fe && s.finish) c.push(fe.label);
          if (q) c.push(cyp.money(s.type ? q.total : q.base));
          toggle = true;
        }
        cm = 'Same piece, same price. Only the metal changes.';
      } else if (st === '4' || st === '4b') {
        var surf = pc ? cyp.settings.surfaces[pc.family] : '';
        e = em = st === '4b' && s.type === 'crest' ? '04 · Crest preview' : st === '4b' ? '04 · Live preview' : '04 · The engraving surface';
        if (st === '4') em = '04 · The surface';
        t = surf;
        var detail = [];
        if (s.type === 'text') detail = [cyp.KINDS[s.kind], s.value || '—', cyp.FONTS[s.font]];
        else if (s.type === 'crest') detail = ['Crest', 'Placeholder until your file arrives'];
        else if (s.type === 'none') detail = ['No engraving'];
        if (pc) {
          src = cyp.imageFor(s, s.finish);
          toggle = true;
        }
        c = [FACE].concat(detail);
        cm = detail.length ? detail.join(' · ') : (q ? 'From ' + cyp.money(q.base) : '');
      }

      eyebrow.textContent = e;
      eyebrowM.textContent = em;
      title.textContent = t;
      title.dataset.len = t.length > 12 ? 'l' : 's';
      cap.textContent = c.join(' · ');
      capM.textContent = cm;
      cap.parentNode.hidden = !c.length && !cm;

      setPhoto(src);

      // Front | Back
      faceBox.hidden = !toggle;
      var f = toggle ? face : 'front';
      fig.dataset.face = f;
      faceBtns.forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-face-btn') === f ? 'true' : 'false'); });
      if (toggle) {
        var sig = [shown.piece, shown.finish, shown.type, shown.value, shown.font].join('|');
        if (sig !== backSig) {
          backSig = sig;
          back.innerHTML = cyp.backPlate(shown);
        }
        var th = src ? cyp.sized(src, 300) : '';
        if (th && thumbImg.getAttribute('src') !== th) thumbImg.src = th;
        note.textContent = shown.type === 'crest'
          ? 'Back drawn as a flat template. Dashed line = engrave area; the crest outline stands in for your logo.'
          : 'Back drawn as a flat template until clean back photography lands. Dashed line = engrave area.';
        if (f === 'back') window.requestAnimationFrame(function () { cyp.fitBack(back); });
      } else if (backSig) {
        backSig = '';
        back.innerHTML = '';
      }

      // running totals beside the step 04 CTAs (desktop) and inside them (mobile)
      var tot = q ? cyp.money(q.total) : '';
      root.querySelectorAll('[data-pb-total], [data-pb-total-m]').forEach(function (el) { el.textContent = tot; });

      if (q && pc) {
        var amount = s.type ? q.total : q.base;
        if (lastTotal !== null && amount !== lastTotal && priceLive) priceLive.textContent = 'Your piece, ' + cyp.money(amount);
        lastTotal = amount;
      }
    }

    faceBtns.forEach(function (b) {
      b.addEventListener('click', function () {
        var want = b.getAttribute('data-face-btn');
        if (want === face) return;
        face = want;
        render();
        cyp.announce(want === 'back' ? 'Showing the back, drawn as a template.' : 'Showing the front.');
        cyp.track('canvas_face', { face: want, step: cyp.step });
      });
    });

    if (window.ResizeObserver) new ResizeObserver(function () { if (fig.dataset.face === 'back') cyp.fitBack(back); }).observe(fig);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { cyp.fitBack(back); });

    cyp.on('state', render);
    cyp.on('step', function (d) {
      if (d.step !== d.prev) face = defaultFace(d.step);
      render();
    });
  });
})();
